import {
  createCommentOnCurrentScreen,
  listCommentsByCurrentScreen,
  replyToCommentThread
} from "../../designer-comment-actions";
import { getSdInstance } from "../helpers";
import type { ToolHandlerGroup } from "../types";

export const commentTools: ToolHandlerGroup = {
  async: {
    ui_project_list_comments: async () => {
      return listCommentsByCurrentScreen(getSdInstance());
    },

    ui_project_post_comment: async (input) => {
      const { kuikaId, text } = input;
      if (!kuikaId) return { error: "kuikaId is required" };
      if (!text) return { error: "text is required" };

      const result = await createCommentOnCurrentScreen(getSdInstance(), {
        kuikaId: kuikaId.toString(),
        text
      });
      if ("error" in result) return result;

      return {
        success: true,
        message: `Comment posted on component ${kuikaId}`,
        comment: result.comment
      };
    },

    ui_project_reply_to_comment: async (input) => {
      const { kuikaId, text } = input;
      if (!kuikaId) return { error: "kuikaId is required" };
      if (!text) return { error: "text is required" };

      const result = await replyToCommentThread(getSdInstance(), {
        kuikaId: kuikaId.toString(),
        text
      });
      if ("error" in result) return result;

      return {
        success: true,
        message: `Reply added to comment thread on component ${kuikaId} (order: ${result.order})`,
        comment: result.comment
      };
    }
  }
};
